export default [
  {
    path: '/thunder/png',
    name: 'photoCollection',
    component: () => import('@/views/photo/collection.vue'), // 修改为 .vue 后缀
    children: [
      {
        path: 'photo',
        name: 'photo_png',
        component: () => import('@/views/photo/single-photo.vue'), // 修改为 .vue 后缀
        meta: {
          title: '照片祝福',
        },
      },
      {
        path: 'photov2',
        name: 'photov2_png',
        component: () => import('@/views/photo/multi-photo.vue'), // 修改为 .vue 后缀
        meta: {
          title: '照片祝福',
        },
      },
      {
        path: 'bless/:id',
        name: 'bless_sort',
        component: () => import('@/views/bless/love-bless.vue'), // 修改为 .vue 后缀
        meta: {
          title: '表白祝福',
        },
      },
      {
        path: 'aiphoto',
        name: 'aiphoto_png',
        component: () => import('@/views/aiphoto/index.vue'), // 修改为 .vue 后缀
        meta: {
          title: '变装合影',
        },
      },
      {
        path: 'screengift',
        name: 'screengift_png',
        component: () => import('@/views/gift/screen-gift-fixed.vue'), // 使用新的修复后的组件
        meta: {
          title: '专属礼物',
        },
      },
      {
        path: 'wallpaper',
        name: 'wallpaper_png',
        component: () => import('@/views/wallpaper/list.vue'),
        meta: {
          title: '手机壁纸',
        },
      },
    ],
  }
];
